const Shell = () => (
  <div className="new-container-fluid neutral-background">
    <div className="new-container">
      <div className="dynamic-breadcrumb">
        <div className="shell-loader" />
      </div>

      <div className="family-header">
        <div className="title">
          <div className="shell-loader" />
        </div>
        <div className="accordion-text-block">
          <div className="shell-loader" />
          <div className="shell-loader" />
          <div className="shell-loader" />
        </div>
      </div>
    </div>
  </div>
)

export default Shell
